import React from 'react';

type Filters = {
  codigo_suscripcion: string;
  payment_method_code: string;
  payment_option: string;
  subscr_status: string;
  account_nif: string;
  consultant_nif: string;
  invoice_account_nif: string;
  legal_name_account: string;
  descripcion: string;
  recurrency: string; 
  last_payment: string | null;
  next_payment: string | null;
  remuneration: string | null;
  item_number: string;
  item_description: string;
  pack_description: string;
  subscription_start_date: string;
};
 
interface FilterProps {
  filters: Filters;
  setFilters: React.Dispatch<React.SetStateAction<Filters>>;
}

const Filter: React.FC<FilterProps> = ({ filters, setFilters }) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({ ...prevFilters, [name]: value }));
  };

  return (
    <div className="filter-container">
      <input
        type="text"
        name="payment_method_code"
        value={filters.payment_method_code}
        onChange={handleInputChange}
        placeholder="Método de pago"
        className="form-control mb-2"
      />
      <select
        name="subscr_status"
        value={filters.subscr_status}
        onChange={handleInputChange}
        className="form-control mb-2"
      >
        <option value="">Seleccione Estado</option>
        <option value="Active">Active</option>
        <option value="Inactive">Inactive</option>
        <option value="Migrated">Migrated</option>
      </select>

      <input
        type="text"
        name="consultant_nif"
        value={filters.consultant_nif}
        onChange={handleInputChange}
        placeholder="Cuenta Principal"
        className="form-control mb-2"
      />
      <input
        type="text"
        name="account_nif"
        value={filters.account_nif}
        onChange={handleInputChange}
        placeholder="Cuenta Miembro"
        className="form-control mb-2"
      />

      <input
        type="text"
        name="invoice_account_nif"
        value={filters.invoice_account_nif}
        onChange={handleInputChange}
        placeholder="Cuenta Facturación"
        className="form-control mb-2"
      />

      <input
        type="text"
        name="item_number"
        value={filters.item_number}
        onChange={handleInputChange}
        placeholder="Número de Servicio"
        className="form-control mb-2"
      />

      <input
        type="text"
        name="item_description"
        value={filters.item_description}
        onChange={handleInputChange}
        placeholder="Descripción del Servicio"
        className="form-control mb-2"
      />

      <input
        type="text"
        name="pack_description"
        value={filters.pack_description}
        onChange={handleInputChange}
        placeholder="Descripción del Pack"
        className="form-control mb-2"
      />           

<input
        type="date"
        name="subscription_start_date"
        value={filters.subscription_start_date}
        onChange={handleInputChange}
        placeholder="Fecha de Inicio de Suscripción"
        className="form-control mb-2"
      />
    </div>
  );
};

export default Filter;
